import React from 'react';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import ProgressSpinner
  from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import { faArchive, faWarning, faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import useArchiveDevice from '../../useArchiveDevice';
import {
  selectDevicesByDeviceIds,
} from '../../../../redux/slices/filteredDeviceListSlice/filteredDeviceListSlice';

/* istanbul ignore next */
function BulkArchiveDevicesModal(props) {
  const {
    deviceIdList,
    onClose,
    onArchive,
  } = props;

  const { archiveDevices, submitting, submitted } = useArchiveDevice();
  const deviceList = useSelector(selectDevicesByDeviceIds(deviceIdList));

  if (submitted) {
    onClose();
  }

  return (
    <>
      <Modal
        show
        onHide={onClose}
        animation={false}
      >
        <Modal.Header>
          <div className="mx-auto text-center">
            <h3>
              <FontAwesomeIcon icon={faArchive} className="text-muted" />
              {' '}
              Archive Device
            </h3>
          </div>
        </Modal.Header>
        <Modal.Body>
          <>
            <div className="alert alert-warning">
              <FontAwesomeIcon icon={faWarning} />
              {' '}
              You are about to archive
              {' '}
              {deviceList.length}
              {' '}
              devices:
              {' '}
              <b>{deviceList.map((device) => device.deviceName).join(', ')}</b>
              .
            </div>
            <p>
              These devices will be available in your
              {' '}
              <i>Archived</i>
              {' '}
              list
              for historical reference.
              Alerts for these devices will be deleted. This action cannot
              be undone.
            </p>
            <p className="small">
              You can completely remove these devices from your account by
              first archiving them,
              then deleting them from the
              {' '}
              <i>Archived</i>
              {' '}
              devices list.
            </p>
            <br />
            <div className="alert alert-info">
              <p><b>Is your Room Alert Monitor offline?</b></p>
              <p>
                If your Room Alert Monitor appears as
                {' '}
                <b>Offline</b>
                {' '}
                or
                {' '}
                <b>Not Connected</b>
                {' '}
                in your Room Alert Account, follow these
                {' '}
                <a
                  href="js/src/components/devices/ArchiveDeviceButton/ArchiveDeviceModal/ArchiveDeviceModal"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  troubleshooting steps
                </a>
                .
                Removing the device and re-registering it will
                {' '}
                <b>not</b>
                {' '}
                resolve the issue.
                {' '}
                <a
                  href="https://avtech.com/support"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Contact our Technical Support Team
                </a>
                {' '}
                for further assistance.
                {' '}
                <a
                  href="js/src/components/devices/ArchiveDeviceButton/ArchiveDeviceModal/ArchiveDeviceModal"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                </a>
              </p>
            </div>
          </>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col ml-auto">
              <Button
                variant="secondary"
                onClick={onClose}
              >
                Cancel
              </Button>
              {' '}
              <Button
                variant="primary"
                onClick={() => archiveDevices(deviceIdList, onArchive)}
                disabled={submitting}
              >
                {submitting
                  ? (
                    <div className="row mx-1 d-flex justify-content-center">
                      <ProgressSpinner useSmallSpinner progressText="" />
                      Archiving...
                    </div>
                  )
                  : (<>Archive Devices</>)}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

BulkArchiveDevicesModal.propTypes = {
  deviceIdList: PropTypes.arrayOf(PropTypes.number).isRequired,
  onClose: PropTypes.func.isRequired,
  onArchive: PropTypes.func.isRequired,
};

export default BulkArchiveDevicesModal;
